export enum AdminTableTypes {
	Approved = 'approved',
}